const DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS = {
  inProgress: 'IN_PROGRESS',
  complete: 'COMPLETE',
  completeWithErrors: 'COMPLETE_WITH_ERRORS',
  failed: 'FAILED',
};

export default DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS;
